import { render, staticRenderFns } from "./UserCards.vue?vue&type=template&id=1ca1bb5c&scoped=true"
import script from "./UserCards.vue?vue&type=script&lang=js"
export * from "./UserCards.vue?vue&type=script&lang=js"
import style0 from "./UserCards.vue?vue&type=style&index=0&id=1ca1bb5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1bb5c",
  null
  
)

export default component.exports